// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@2.1.10_@swc+helpers@0.5.23__webpack@5.104.1_@swc+core@1.1_f4893ebf28ed7f924e57e0016ea700de/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_@rspack+core@2.1.10_@swc+helpers@0.5.23__webpack@5.104.1_@swc+core@1.1_f4893ebf28ed7f924e57e0016ea700de/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZAfzLAU1qqEJZfW1 {
  vertical-align: middle;
  flex: none;
  display: inline-block;
}

.DnVk2nMmguM1DpFh {
  fill: var(--lp-color-fill-ui-primary);
}

.wAfls_xJ_fE55R3c {
  fill: var(--lp-color-fill-ui-secondary);
}

.gnOlcI14kF0Cigg_ {
  height: var(--lp-size-12);
  width: var(--lp-size-12);
}

._s1P4gjytAM3sZOG {
  height: var(--lp-size-16);
  width: var(--lp-size-16);
}

.s2gGWsVan4AULAZA {
  height: var(--lp-size-20);
  width: var(--lp-size-20);
}

.ve1e_sO87YqROWFg {
  height: var(--lp-size-40);
  width: var(--lp-size-40);
}
`, "",{"version":3,"sources":["webpack://./../../launchpad-ui/packages/icons/src/styles/Icon.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B","sourcesContent":[".base {\n  vertical-align: middle;\n  flex: none;\n  display: inline-block;\n}\n\n.default {\n  fill: var(--lp-color-fill-ui-primary);\n}\n\n.subtle {\n  fill: var(--lp-color-fill-ui-secondary);\n}\n\n.tiny {\n  height: var(--lp-size-12);\n  width: var(--lp-size-12);\n}\n\n.small {\n  height: var(--lp-size-16);\n  width: var(--lp-size-16);\n}\n\n.medium {\n  height: var(--lp-size-20);\n  width: var(--lp-size-20);\n}\n\n.large {\n  height: var(--lp-size-40);\n  width: var(--lp-size-40);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": `ZAfzLAU1qqEJZfW1`,
	"default": `DnVk2nMmguM1DpFh`,
	"subtle": `wAfls_xJ_fE55R3c`,
	"tiny": `gnOlcI14kF0Cigg_`,
	"small": `_s1P4gjytAM3sZOG`,
	"medium": `s2gGWsVan4AULAZA`,
	"large": `ve1e_sO87YqROWFg`
};
export default ___CSS_LOADER_EXPORT___;
